import { render, staticRenderFns } from "./gender5.vue?vue&type=template&id=9142a612&"
import script from "./gender5.vue?vue&type=script&lang=js&"
export * from "./gender5.vue?vue&type=script&lang=js&"
import style0 from "./gender5.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports